/**
 * Firebase rejects with a FirebaseError carrying a `code` like
 * 'auth/email-already-in-use' or 'permission-denied', but TypeScript types
 * every catch binding as `unknown`. These narrow it safely rather than each
 * call site casting.
 */

/** The Firebase error code, or '' if this is not a coded error. */
export function errorCode(error: unknown): string {
  if (typeof error === 'object' && error !== null && 'code' in error) {
    const { code } = error as { code?: unknown };
    if (typeof code === 'string') return code;
  }
  return '';
}

/** A human-readable message for any thrown value. */
export function errorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  return 'An unexpected error occurred';
}

/** True when the failure is the browser (or Firestore) being offline. */
export function isOfflineError(error: unknown): boolean {
  return (
    !navigator.onLine ||
    errorCode(error) === 'failed-precondition' ||
    errorMessage(error).includes('offline')
  );
}
